import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > div': {
      margin: '0'
    }
  },
  heading: {
    color: theme.palette.common.black,
    fontWeight: 500,
    fontSize: '1.5625rem'
  },
  cameraMainConatiner: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: '0.5rem'
  },
  cameraFrameContainer: {
    width: '32.125rem',
    height: '23.375rem',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: 'auto'
    },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    '& .ReactCrop': {
      display: 'inline-block',
      width: '100%',
      maxWidth: '100%',
      overflow: 'hidden',
      position: 'relative',
      height: '100%'
    },
    '& .ReactCrop__child-wrapper': {
      height: '100%',
      maxHeight: '100%',
      transform: 'scale(1) rotate(0deg)',
    }
  },
  cameraFaceBorder: {
    width: '70%',
    height: '60%',
    position: 'absolute',
    border: '4px dotted #fff',
  },
  secondaryBtnWrapper: {
    textAlign: 'right',
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
    },
  },
  primaryBtnWrapper: {
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
    },
  },
  cameraOpenWrapper: {
    width: '100%',
    height: '100%'
  },
  cropImagePreview: {
    width: '100%',
  },
  cameraTakeView: {
    display: 'block',
    width: '100%',
    objectFit: 'cover',
    height: '100%',
    maxHeight: '100%',
  }
}));
